import Header from "../components/homeHeader";
import ChartArea from "../components/homeChartArea";
import ChartArea2 from "../components/homeChartArea2";
import { Grid } from "@material-ui/core";
import ProjectStatistics from "../components/projectStatistics";
import ConsumptionChart from "../components/homeConsumptionChart";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import useCustomState from "../hooks/State";
import { useHistory } from "react-router";
import { UpdateNavigations } from "../store/actions";
import { useDispatch } from "react-redux";

const Home = () => {
  const user = useSelector((state) => state.user);

  const history = useHistory();

  const allowRender = useCustomState(false);

  useEffect(() => {
    const permissions = user.permissions;
    if (permissions.includes("Middle")) {
      history.push("/admin/projects");
    } else {
      allowRender.handleChange(true);
    }
  }, []);

  const isLoading = useCustomState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    const navigations = [];
    dispatch(UpdateNavigations(navigations));
    isLoading.handleChange(false);
    window.localStorage.removeItem("dashHistory");
  }, []);

  if (allowRender.value) {
    return (
      <>
        <div style={{ paddingBottom: "24px" }}>
          <Header />
          <ChartArea />
          <ConsumptionChart />
          <Grid container>
            <Grid item sx={12} sm={12} md={12} lg={6}>
              <ProjectStatistics />
            </Grid>
            <Grid item sx={12} sm={12} md={12} lg={6}>
              <ChartArea2 />
            </Grid>
          </Grid>
        </div>
      </>
    );
  } else {
    return null;
  }
};

export default Home;
